import { CommonModule, DatePipe } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { NgbCarouselModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { PageHeaderComponent } from '../../core/components/page-header/page-header.component';
import { LanguageEnum } from '../../core/enums/languageEnum';
import { PublicService } from '../../core/services/public.service';
import { LeagueAchievementResponse, LeagueMemberResponse, NewsResponse } from '../technical-committee.interface';
import { TechnicalCommitteeService } from '../technical-committee.service';
import { leagueEnum } from '../league.enum';
import { TechnicalCommitteeNewsCardComponent } from '../technical-committee-news-card/technical-committee-news-card.component';
import { LeagueSubscriptionComponent } from '../league-subscription/league-subscription.component';

@Component({
  selector: 'app-arab-actuaries-league',
  standalone: true,
  providers: [DatePipe],
  templateUrl: './arab-actuaries-league.component.html',
  styleUrl: './arab-actuaries-league.component.scss',
  imports: [TechnicalCommitteeNewsCardComponent, TechnicalCommitteeNewsCardComponent, PageHeaderComponent, TranslateModule, CommonModule, NgbCarouselModule]
})
export class ArabActuariesLeagueComponent implements OnInit, OnDestroy {

  isArabic: boolean = false;
  publicService = inject(PublicService);
  translateService = inject(TranslateService);
  technicalCommitteeService = inject(TechnicalCommitteeService);
  subscription = new Subscription();
  achievementList: LeagueAchievementResponse[] = [];
  memberList: LeagueMemberResponse[] = [];
  newsList: NewsResponse[] = [];
  title: string = 'technicalCommittee.technicalCommittee';

  constructor(private datePipe: DatePipe, private modalService: NgbModal) {
    this.isArabic = this.translateService.getDefaultLang() == 'en' ? false : true;
    this.subscription.add(this.translateService.onDefaultLangChange.subscribe((res) => {
      if (res) {
        this.isArabic = res.lang == 'en' ? false : true;
      }
    }));
  }
  //#region angular lifecycle
  ngOnInit(): void {

    let currentLanguage = this.publicService.getAppCurrentLanguage();
    this.isArabic = currentLanguage == 'en' ? false : true;
    this.getLeagueAchievementWebsite();
    this.getLeagueMemberWebsiteList();
    this.getNews();
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  //#endregion
  //#region Methods
  getLeagueAchievementWebsite() {
    this.subscription.add(this.technicalCommitteeService.getActuariesLeagueAchievementWebsite().subscribe(res => {
      if (res) this.achievementList = res;
    }))
  }
  getLeagueMemberWebsiteList() {
    this.subscription.add(this.technicalCommitteeService.getLeagueMemberWebsiteList().subscribe(res => {
      if (res) this.memberList = res.filter(x => x.leagueId == leagueEnum.Actuaries);
    }))
  }
  getNews() {
    this.subscription.add(this.technicalCommitteeService.getActuariesLeaguePageNews(this.isArabic ? LanguageEnum.Arabic : LanguageEnum.English).subscribe(res => {
      if (res) this.newsList = res;

    }))
  }
  downloadAttachedPDF(item: LeagueAchievementResponse) {
    this.publicService.displayPDF((this.isArabic ? item.pdfArFullPath : item.pdfEnFullPath), "show")
  }

  downloadAttachedNewsPDF(item: NewsResponse) {
    this.publicService.displayPDF((item.pdfFullPath), "show");
  }
  // convertMonthNumberToText(monthNumber: number): any {
  //   const date = new Date();
  //   date.setMonth(monthNumber - 1);
  //   return this.datePipe.transform(date, 'MMMM');
  // }
  //#endregion
  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = '/assets/images/news-error-img.png';
  }

  subscribe() {
    let subscriptionCompanyComponent = this.modalService.open(LeagueSubscriptionComponent,
      { centered: true, backdrop: 'static', modalDialogClass: 'rounded-module', size: 'xl' });
    subscriptionCompanyComponent.result.then((res) => {
      if (res) {
      }
    }).catch((err) => { })
  }
}
